/**
 * "Come back here after signing in." The login page receives the original location in a
 * `redirect` query parameter and returns to it once the session exists.
 */

export const LOGIN_REDIRECT_PARAM = 'redirect';

const AUTH_PATHS = ['/login', '/logout', '/register', '/register-invite', '/forgot-password', '/reset-password'];

/** Path of the login page that leads back to `location` afterwards; plain /login for auth pages themselves. */
export const loginPathFor = (location: { pathname: string; search?: string; hash?: string }): string => {
  const target = `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`;
  if (!target || target === '/' || AUTH_PATHS.some((path) => location.pathname.startsWith(path))) return '/login';
  return `/login?${LOGIN_REDIRECT_PARAM}=${encodeURIComponent(target)}`;
};

/**
 * The place to go after login, given the raw parameter. Only same-origin paths are honoured:
 * anything that could leave the site (a scheme, a protocol-relative `//host`) falls back to home.
 */
export const safeRedirectTarget = (raw: string | null | undefined): string => {
  if (!raw) return '/';
  const target = raw.trim();
  if (!target.startsWith('/') || target.startsWith('//') || target.startsWith('/\\')) return '/';
  if (AUTH_PATHS.some((path) => target.startsWith(path))) return '/';
  return target;
};
